import { create } from 'zustand';
import { IModel, ModelTypes } from '../../../features/chat/types/model.types';
// import { useChatStore } from './use-chat-store';
// import { Atom } from 'lucide-react';
import React from 'react';
import modelIcon from '../../../assets/images/modelIcon.svg';

interface ModelStoreState {
  selectedModel: IModel | null;
  setSelectedModel: (model?: string) => void;
  openNewChatWithModel: (model: IModel) => void;
  models: IModel[];
  setModels: (models: IModel[]) => void;
  getModelById: (modelId: string) => IModel | null;
  reset: () => void;
  userChangedModel: ( userChangedModel: boolean ) => void;
  isUserChangedModel: boolean;
  lastUsedModelId: string | null;
  lastUsedViaSmart: boolean;
  setLastUsedFromSmart: (modelId: string | null) => void;
}

const autoModel: IModel = {
  id: 'auto',
  name: 'Smart',
  description: 'AUTO_DESC',
  modelType:ModelTypes.VISION,
  isThinkingModel: false,
  icon: React.createElement('img', { src: modelIcon, alt: 'Smart', className: 'w-4 h-4' }),
  isDefaultModel: true,
  order: 0,
  hasDynamicThinking: false,
  isHarmonicModel: false,
};

export const useModelStore = create<ModelStoreState>((set, get) => ({
  selectedModel: null,
  models: [],
  isUserChangedModel: false,
  lastUsedModelId: null,
  lastUsedViaSmart: false,
  setLastUsedFromSmart: (modelId) => {
    set({
      lastUsedModelId: modelId,
      lastUsedViaSmart: Boolean(modelId),
    });
  },
  userChangedModel: (userChangedModel: boolean) => {
    set({ isUserChangedModel: userChangedModel });
  },
  setModels: (models) => {
    models = [autoModel,...models];
    const defaultModel = models.find((model) => model.isDefaultModel) ?? autoModel;
    set({ models });
    if (!get().selectedModel) set({ selectedModel: defaultModel });
  },
  setSelectedModel: (modelId) => {
    // console.log('modelId in setSelectedModel', modelId)
    if (!modelId) {
      set({ selectedModel: null });
      return;
    }

    // const currentModel = get().selectedModel;
    const model = get().models.find((model) => model.id === modelId) ?? null;
    // console.log('model in setSelectedModel', model,modelId)
    set({ selectedModel: model });
    
    // if (currentModel && model && currentModel.id !== model.id) {
    //   console.log('currentModel', currentModel?.id, 'model', model?.id, 'currentModel.id !== model.id', currentModel?.id !== model?.id)
    //   const chatStore = useChatStore.getState();
    //   chatStore.setNewChat(true);
    // }
  },
  openNewChatWithModel: (model) => {
    set({ selectedModel: model });
    // const chatStore = useChatStore.getState();
    // chatStore.setActiveConversationId(null);
    // chatStore.setNewChatWithModel(true);
  },
  getModelById: (modelId: string) => {
    return get().models.find((model) => model.id === modelId) ?? null;
  },
  reset: () => {
    set({
      selectedModel: null,
      models: [],
    });
  },
}));
